class Formation < ApplicationRecord
  belongs_to :person
  belongs_to :solo
end
